<template>
<nav>
    <div class="nav">
        <img src="../assets/logo.png" alt="" class="logo"/>
        <ul class="menu">
            <li v-on:click="clickMenu('home')">Home</li>
            <li v-on:click="clickMenu('introduce')">Introduce</li>
            <li v-on:click="clickMenu('book')">Book</li>
            <li v-on:click="clickMenu('contact')">Contact</li>
        </ul>
    </div>
</nav>
</template>
<script>
export default {
    name: 'Nav',
    methods: {
        clickMenu(id) {
            document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
        }
    }
}
</script>
<style>
nav {
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 100;
    width: 100%;
}
nav .logo {
    width: 200px;
}
.nav {
    width: 1000px;
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

}
ul {
    list-style-type: none;
}
.menu {
    display: flex;
    padding: 0;
    margin: 0;
    align-items: center;
}
.menu li {
    margin-right: 30px;
    cursor: pointer;
}
.menu li:last-child {
    margin-right: 0;
}
.menu li:hover {
    font-weight: bolder;
}
@media screen and (max-width: 414px) {
    nav {
        width: 100vw;
        position: sticky;
    }

    nav .logo {
        width: 30vw;
    }

    .nav {
        justify-content: center;
    }

    .menu {
        display: none;
    }

}
@media screen and (min-width: 768px) and (max-width: 1000px) {
    nav {
        width: 100vw;
        position: sticky;
    }
    nav .logo {
        width: 15vw;
    }
}
@media screen and (min-width: 717px) and (max-height: 512px) {
    nav {
        width: 100vw;
        position: sticky;
    }
    nav .logo {
        width: 15vw;
    }
}
</style>
